import { render } from "./HeroiconsSolidShoppingBag.vue?vue&type=template&id=bc40903e"
const script = {}

import exportComponent from "/Users/dorinpuscasu/Desktop/Projects/linella/linella-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidShoppingBag.vue"]])

export default __exports__